import { onAuthStateChanged } from 'firebase/auth';
import { firebase } from '@/lib/firebaseConfig';
import { useEffect, useState } from 'react';
import type { User } from 'firebase/auth';

type UserState =
  | { type: 'unknown' }
  | { type: 'authenticated'; user: User }
  | { type: 'unauthenticated' };

export const useCurrentUser = () => {
  const [state, setState] = useState<UserState>({
    type: 'unknown',
  });

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(firebase.auth, async (user) => {
      if (user) {
        setState({
          type: 'authenticated',
          user,
        });
      } else {
        setState({
          type: 'unauthenticated',
        });
      }
    });
    return () => unsubscribe();
  }, []);

  return state;
};
